import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { StepList, BUTTON_TYPE, StepListProps } from '@bepure/tarkin';
import { renderPrePurchaseButton } from './PrePurchaseButton';

class StepsSection extends React.PureComponent<StepListProps> {
    public render() {
        const { title, steps, button, children } = this.props;
        return (
            <StepList title={title} steps={steps} button={button} children={children} />
        );
    }
}

export default function render() {
    const elements = document.getElementsByClassName('steps-section');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        const stepsTitle = element.dataset.title || '';
        const children = Array.prototype.slice.call(element.children)
        const steps = children.filter((child: HTMLElement) => child.dataset.imageurl).map((child: HTMLElement) => {
            return {
                imageUrl: child.dataset.imageurl || '',
                description: child.dataset.steptitle || '',
            };
        });
        const buttonText = 'Buy Now';
        const buttonClasses = 'step-list__button';
        const link = `/store`;
        const button = renderPrePurchaseButton(BUTTON_TYPE.PRIMARY, buttonText, buttonClasses, link);

        return ReactDOM.render(
            <StepsSection title={stepsTitle} steps={steps} children={button} />,
            element,
        );
    });

}
